<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      上李朗站<br>
站点介绍<br>
上李朗站位于深圳市龙岗区平吉大道和佳宝路交叉口，车站主体呈南北走向，南接凉帽山站，北接木古站。 上李朗站色彩基调以蓝色为主，为地下二层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有3个出入口，周边为仓储、工业及医疗卫生规划用地。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:30	23:11	10号线	3分40秒	6分钟<br>
双拥街	06:07	23:43	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:30	23:11	10号线	4分50秒	7分钟<br>
双拥街	06:22	23:43	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:30	00:11	10号线	4分50秒	7分钟<br>
双拥街	06:16	00:43	10号线	4分50秒	7分钟<br><br>

站点出口信息<br>
A出入口:<br>
平吉大道东侧、左右家私、康利城<br><br>
B出入口:<br>
平吉大道西侧（北）<br><br>
C出入口:<br>
平吉大道西侧（南）、左右云创谷、建昇大厦、华熠大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 上李朗地铁站<br>
322、977、M227、M300、M311、M589<br><br>
C出入口:<br>
公交站名： 上李朗地铁站<br>
322、977、M227、M300、M311、M589<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>